import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldAlert, ArrowLeft, Home, Lock } from "lucide-react";

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-b from-primary-50 to-background flex items-center justify-center px-4">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="max-w-md w-full text-center"
            >
                <div className="relative mb-8">
                    <div className="w-24 h-24 bg-gradient-to-br from-red-100 to-red-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                        <ShieldAlert className="w-12 h-12 text-red-600" />
                    </div>
                    <motion.div
                        animate={{ rotate: 360 }}
                        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                        className="absolute inset-0 border-4 border-red-200 border-t-transparent rounded-full"
                    />
                </div>

                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                    Access Restricted
                </h1>

                <p className="text-gray-600 mb-8">
                    You don't have permission to access this page. This area requires
                    specific role-based permissions that your account doesn't currently have.
                </p>

                <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-8">
                    <div className="flex items-start space-x-3">
                        <Lock className="w-5 h-5 text-red-600 mt-0.5" />
                        <div className="text-left">
                            <h3 className="font-medium text-red-800 mb-1">Permission Required</h3>
                            <p className="text-sm text-red-700">
                                Contact your administrator if you believe you should have access to this resource.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center space-x-2 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        <span>Go Back</span>
                    </motion.button>

                    <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => navigate("/")}
                        className="flex items-center justify-center space-x-2 px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
                    >
                        <Home className="w-4 h-4" />
                        <span>Home Page</span>
                    </motion.button>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                        Need help? Contact support at{" "}
                        <a href="mailto:support@teamhub.com" className="text-primary-600 hover:text-primary-700">
                            support@teamhub.com
                        </a>
                    </p>
                </div>
            </motion.div>
        </div>
    );
};

export default Unauthorized;